import { SignupFieldOptions } from "types/sub/application"
import { SubChildrenSelectStyle } from "./style"
import { useEffect, useState } from "react"
import { Select } from "antd"

type SelectItem = {
    label: number[], children: number[]
}

export const UploadSubChildrenSelect = (props: { value?: any, onChange?: (val: SelectItem) => void, multiple?: boolean, data?: SignupFieldOptions[], theme2?: number[], type?: string }) => {
    const [first, setFirst] = useState<number>(0);
    const [second, setSecond] = useState<number>(0);
    const [secondData, setSecondData] = useState<SignupFieldOptions[]>([])


    useEffect(() => {
        if (!props?.data) {
            return
        }
        if (!props.value) {
            setFirst(props.data[0].id)
            setSecondData(props.data[0].children)
            setSecond(props.data[0].children[0].id)
        } else {
            if (props.value.constructor !== Object) {
                setFirst(props.value[0])
                let index = props.data.findIndex((item) => item.id === props.value[0])
                setSecondData(props.data[index].children)
                if (props.value.length > 1) {
                    setSecond(props.value[1])
                }
            } else {
                setFirst(props.value.label[0])
                setSecond(props.value.children[0])
                let index = props.data.findIndex((item) => item.id === props.value.label[0])
                setSecondData(props.data[index].children)
            }

        }
    }, [props.value, props.data])

    const handleFirstChange = (value: number) => {
        if (!props.data) return
        setFirst(value)
        let index = props.data.findIndex((item) => item.id === value)
        setSecondData(props.data[index].children)
        setSecond(props.data[index].children[0].id)
        props.onChange!({ label: [value], children: [props.data[index].children[0].id] })
    };

    const handleSecondChange = (value: number) => {
        setSecond(value)
        props.onChange!({ label: [first], children: [value] })
    }

    return <SubChildrenSelectStyle>
        <div className="second-select-container">
            <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                <Select
                    style={{ width: '48%' }}
                    value={first}
                    onChange={handleFirstChange}
                    options={props.data && props.data.map((item) => ({ label: item.name, value: item.id }))}
                />

                <Select
                    style={{ width: '48%' }}
                    value={second}
                    onChange={handleSecondChange}
                    options={secondData?.map((item) => ({ label: item.name, value: item.id }))}
                />
            </div>
        </div>
    </SubChildrenSelectStyle>
}